import { Helper } from "../util/helper.js";
import React from "react";
export class FAIcon extends React.Component<FAIconProps, any>{
    private _ref: HTMLElement;

    private _setRef = (r) => {
        if (r !== null) {
            this._ref = r;
            let that = this;
            if (this.props.renderSvgComplete) {
                var observer = new MutationObserver(function (mutations) {
                    mutations.forEach(function (mutation) {
                        for (let i = 0; i < mutation.addedNodes.length; i++) {
                            if (mutation.addedNodes[i].nodeName == "svg") {
                                observer.disconnect();
                                that.props.renderSvgComplete();
                            }
                        }
                    });
                });
                observer.observe(this._ref, { childList: true });
            }
        }
    }

    render() {
        const attr = Array.isArray(this.props.attributes) ? (" " + this.props.attributes.map(a => "fa-" + a).join(" ") + " ") : "";
        const wrapperClasses = [(this.props.spins ? "spinner" : ""), (this.props.wrapperClass || "")].join(" ")
        return (
            <div ref={(r) => this._setRef(r)} key={`fa-${this.props.name}`} style={this.props.style} className={wrapperClasses} title={this.props.wrapperToolTip}>
                <i className={`${Helper.isNullOrEmpty(this.props.prefix) ? "fal" : this.props.prefix} fa-${this.props.name} ${this.props.sameWidth !== false ? `fa-fw` : ``}` + attr} aria-hidden="true"></i>
            </div>
        )
    }
}

export interface FAIconProps extends React.PropsWithChildren {
    name: string;
    sameWidth?: boolean;
    style?: React.CSSProperties;
    attributes?: Array<string>;
    renderSvgComplete?();
    wrapperClass?: string;
    wrapperToolTip?: string;
    prefix?: "fal" | "far" | "fas" | "fa";
    spins?: boolean;
}